import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ENTERPRISE_CARD_ENABLED } from '../../../constants/ebon';
import { ENTERPRISE_CARD } from '../../../constants/paymentMethods';

import EnterpriseCard from './payment-methods/EnterpriseCard';

import './FunnelPaymentStepStyle.scss';

const FunnelPaymentStep = ({ userInfo, partnerId, order, paymentType }) => {
    return (
        <div id="payment-step-container">
            {paymentType === ENTERPRISE_CARD && ENTERPRISE_CARD_ENABLED && (
                <EnterpriseCard userInfo={userInfo} partnerId={partnerId} order={order} />
            )}
        </div>
    );
};

FunnelPaymentStep.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    paymentType: PropTypes.string
};

const mapStateToProps = state => {
    return {
        order: state.ebon.createdOrder
    };
};

export default connect(mapStateToProps)(FunnelPaymentStep);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/FunnelPaymentStep.js